import type { Principal } from '../../controlled/commonTypes';

import {
	type ShareAndRestrictDialogQuery_user_AtlassianUser as ShareAndRestrictDialogQuery_user,
	type ShareAndRestrictDialogQuery_user_AtlassianUser_emails_AtlassianUserEmail as ShareAndRestrictDialogQuery_user_emails,
	type ShareAndRestrictDialogQuery_user_AtlassianUser_photos_AtlassianUserPhoto as ShareAndRestrictDialogQuery_user_photos,
} from './__types__/ShareAndRestrictDialogQuery';

export function getCurrentUserPrincipal(
	user: ShareAndRestrictDialogQuery_user | null,
): Principal | null {
	if (!user) return null;

	// Insist on a bare minimum of profile data
	const { id, displayName, photos, emails } = user;
	if (!id) return null;
	if (!displayName) return null;

	return {
		type: 'user',
		id,
		name: displayName,
		avatarUrl: getPrimaryValue(photos),
		email: getPrimaryValue(emails),
		knownErrors: undefined,
		sitePermissionType: 'INTERNAL',
	};
}

function getPrimaryValue(
	maybeList:
		| (ShareAndRestrictDialogQuery_user_photos | null)[]
		| (ShareAndRestrictDialogQuery_user_emails | null)[]
		| null
		| undefined,
): string {
	let best = '';
	if (maybeList) {
		for (const item of maybeList) {
			if (!item) continue;
			const { value, isPrimary } = item;
			if (!value) continue;
			best = value;
			if (isPrimary) break;
		}
	}
	return best;
}
